<script lang='ts'>
  import { addDays, addWeeks } from "date-fns";

    export let loadedStats: any
    export let displayedStats: any[]
    export let range: [Date, Date]

    $: dateKeys = Object.keys(loadedStats)
        .filter(date => {
            const startOfWeek = new Date(date);
            const endOfWeek = addDays(startOfWeek, 6);
            return (endOfWeek >= range[0] && startOfWeek <= range[1]);
        })
</script>

<div class='overflow-x-scroll'>
    <table>
        <tr>
            <th />
            {#each displayedStats as dStat}
                {#if dStat.preselected}
                    <th>
                        {@html dStat.label}
                    </th>
                {/if}
            {/each}
        </tr>
        {#each dateKeys as dateKey}
            <tr>
                <td>
                    {@html loadedStats[dateKey]['daterange']}
                </td>
                {#each displayedStats as dStat}
                    {#if dStat.preselected}
                        <td>
                            {#if loadedStats[dateKey][dStat.value]}
                                {@html loadedStats[dateKey][dStat.value]}
                            {:else}
                                --
                            {/if}
                        </td>
                    {/if}
                {/each}
            </tr>
        {/each}
    </table>
</div>

<style lang="scss">
    table {
        width: 100%;
    }

    th,td {
        text-align: left;
        padding: 8px;
    }

    tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    th {
        background-color: #016e79;
        color: white;
    }
</style>